import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import type { RiskLevel } from '../../../utils/scanReport';
interface RiskScaleProps {
  score: number;
  riskLevel: RiskLevel;
}
const BANDS: {
  level: RiskLevel;
  label: string;
  range: string;
  width: number;
  fill: string;
  text: string;
}[] = [{
  level: 'low',
  label: 'Low',
  range: '0–39',
  width: 40,
  fill: 'bg-emerald-400',
  text: 'text-emerald-300'
}, {
  level: 'medium',
  label: 'Medium',
  range: '40–69',
  width: 30,
  fill: 'bg-amber-400',
  text: 'text-amber-300'
}, {
  level: 'high',
  label: 'High',
  range: '70–100',
  width: 30,
  fill: 'bg-forensic-crimson',
  text: 'text-forensic-crimson-soft'
}];
const EASE = [0.23, 1, 0.32, 1] as const;

/** Shows where the score sits on the low / medium / high scale. */
export function RiskScale({
  score,
  riskLevel
}: RiskScaleProps) {
  const reduceMotion = useReducedMotion();
  const clamped = Math.max(0, Math.min(100, score));
  return <div role="img" aria-label={`Score ${Math.round(clamped)} falls in the ${riskLevel} risk band`} data-id="element-410" data-mp="12khn9r59g5ia">
      <div className="relative pt-3" data-id="element-411" data-mp="3vgzlqtrmim6m">
        <motion.span aria-hidden="true" className="absolute top-0 -ml-[5px] h-0 w-0 border-x-[5px] border-t-[6px] border-x-transparent border-t-white" initial={reduceMotion ? false : {
        left: '0%'
      }} animate={{
        left: `${clamped}%`
      }} transition={{
        duration: 0.3,
        delay: 0.1,
        ease: EASE
      }} data-id="element-412" data-mp="3qjg038slj74n" />
        <div className="flex gap-1" aria-hidden="true" data-id="element-413" data-mp="3clj0s4mrcmma">
          {BANDS.map(band => <span key={band.level} style={{
          width: `${band.width}%`
        }} className={`h-1.5 rounded-full ${band.fill} ${band.level === riskLevel ? 'opacity-100' : 'opacity-20'}`} data-id="element-414" data-mp="37rwz17i4u359" />)}
        </div>
      </div>
      <div className="mt-2 flex gap-1 text-[11px]" aria-hidden="true" data-id="element-415" data-mp="2swgycjn1r8zw">
        {BANDS.map(band => <span key={band.level} style={{
        width: `${band.width}%`
      }} className={band.level === riskLevel ? `font-semibold ${band.text}` : 'text-forensic-subtle'} data-id="element-416" data-mp="2ovomrjqpcs0g">
            {band.label} <span className="tabular-nums opacity-70" data-id="element-417" data-mp="2ja68u5dyifu6">{band.range}</span>
          </span>)}
      </div>
    </div>;
}